import R from 'ramda'

const ONLY_TRIGGER_TYPE = 'ONLY'
const ONLY_DISPLAY_TYPE = 'Only'

const isOnlyWidgetTrigger = R.propEq('type', ONLY_TRIGGER_TYPE)

const convertOnlyWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(ONLY_DISPLAY_TYPE),
  value: R.prop('data')
})

export { isOnlyWidgetTrigger, convertOnlyWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/instagram/widget-to-form/only.js